/**
 * Enumeration for notating the supported languages in the application. It should be used to send state updates for new language and also react to changes in the state, in order to do run side-effects.
 */
enum ENUM_LANGUAGES {
    IT = 1,
    EN = 2
};

export {
    ENUM_LANGUAGES
};
